import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { getArrayError } from 'CorePackage/MainModule/common/getArrayError';

import { ISignersForm } from '../interfaces/ISignersForm';
import { composeValidators } from '../../../CorePackage/MainModule/validators/composeValidators';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const getSignersValidator = (
  signers: ISignersForm[] | undefined,
): FormErrors<ISignersForm | undefined>[] | string[] | undefined => {
  if (!signers || signers.length === 0) {
    return getArrayError('Поле не может быть пустым');
  }

  return signers.map(signer => {
    if (signer.systemSignature != null) {
      return {};
    }

    const isDuplicate =
      signer.fioSigner && signer.titleSigner
        ? signers.filter(s => {
            if (typeof signer.fioSigner === 'string') {
              return (
                s.fioSigner === signer.fioSigner &&
                (s.titleSigner?.value?.dictVersionId === signer.titleSigner?.value?.dictVersionId ||
                  s.titleSigner?.title?.toLowerCase() === signer.titleSigner?.title?.toLowerCase())
              );
            }

            return (
              (s.fioSigner as ISelectOption)?.value === (signer.fioSigner as ISelectOption)?.value &&
              (s.titleSigner?.value?.dictVersionId === signer.titleSigner?.value?.dictVersionId ||
                s.titleSigner?.title?.toLowerCase() === signer.titleSigner?.title?.toLowerCase())
            );
          }).length > 1
        : false;

    return {
      fioSigner: composeValidators(makeRequired('Поле не может быть пустым'), () =>
        isDuplicate ? 'Указанное должностное лицо есть в списке подписантов!' : undefined,
      )(signer.fioSigner),
      titleSigner: composeValidators(makeRequired('Поле не может быть пустым'), () => (isDuplicate ? ' ' : undefined))(
        signer.titleSigner,
      ),
    };
  });
};
